'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOffers = exports.triggerBonusByPromoCode = exports.preclaimBonus = exports.cancelBonus = exports.rejectBonus = exports.claimBonus = exports.getPendingBonuses = exports.getMonetaryBonuses = exports.getFreeSpins = exports.getBonusById = exports.getBonuses = undefined;

var _utils = require('./utils');

/**
 * Get a list of all bonuses (pending, active, expired, cleared)
 * @param {string} playerSessionID 
 */
var getBonuses = exports.getBonuses = function getBonuses(playerSessionID) {
  return (0, _utils.getProtected)('/bonus', playerSessionID);
};

/**
 * Get detailed information for a specific bonus
 * @param {string} playerSessionID 
 * @param {string} bonusId Id of the bonus to retrieve, the bonus must be belong to the authenticated player
 */
var getBonusById = exports.getBonusById = function getBonusById(playerSessionID, bonusId) {
  return (0, _utils.getProtected)('/bonus/' + bonusId, playerSessionID);
};

/**
 * Get a list of all freespins (excluding pending) BonusAmount is the number of freespins awarded until they have been played at which point the value is the amount won on the freespins
 * @param {string} playerSessionID 
 */
var getFreeSpins = exports.getFreeSpins = function getFreeSpins(playerSessionID) {
  return (0, _utils.getProtected)('/bonus/freespins', playerSessionID);
};

/**
 * Get a list of all monetary bonuses (excluding pending)
 * @param {string} playerSessionID 
 */
var getMonetaryBonuses = exports.getMonetaryBonuses = function getMonetaryBonuses(playerSessionID) {
  return (0, _utils.getProtected)('/bonus/monetary', playerSessionID);
};

/**
 * Get a list of all pending bonuses
 * @param {string} playerSessionID 
 */
var getPendingBonuses = exports.getPendingBonuses = function getPendingBonuses(playerSessionID) {
  return (0, _utils.getProtected)('/bonus/pending', playerSessionID);
};

/**
 * Claim a pending bonus
 * @param {string} playerSessionID 
 * @param {string} bonusId Id of the bonus to claim, the bonus must be belong to the authenticated player
 */
var claimBonus = exports.claimBonus = function claimBonus(playerSessionID, bonusId) {
  return (0, _utils.postProtected)('/bonus/claim/' + bonusId, playerSessionID);
};

/**
 * Reject a pending bonus
 * @param {string} playerSessionID 
 * @param {string} bonusId Id of the bonus to claim, the bonus must be belong to the authenticated player
 */
var rejectBonus = exports.rejectBonus = function rejectBonus(playerSessionID, bonusId) {
  return (0, _utils.postProtected)('/bonus/reject/' + bonusId, playerSessionID);
};

/**
 * Cancel a pending bonus
 * @param {string} playerSessionID 
 * @param {string} bonusId Id of the bonus to claim, the bonus must be belong to the authenticated player
 */
var cancelBonus = exports.cancelBonus = function cancelBonus(playerSessionID, bonusId) {
  return (0, _utils.postProtected)('/bonus/cancel/' + bonusId, playerSessionID);
};

/**
 * Preclaim a bonus using promo code
 * @param {string} playerSessionID 
 * @param {string} promoCode
 */
var preclaimBonus = exports.preclaimBonus = function preclaimBonus(playerSessionID, promoCode) {
  return (0, _utils.postProtected)('/bonus/preclaim/' + promoCode, playerSessionID);
};

/**
 * Trigger a bonus manually using a promo code. The bonus has to be configured with the trigger type PromotionCode
 * @param {string} playerSessionID 
 * @param {string} promoCode
 */
var triggerBonusByPromoCode = exports.triggerBonusByPromoCode = function triggerBonusByPromoCode(playerSessionID, promoCode) {
  return (0, _utils.postProtected)('/bonus/trigger/' + promoCode, playerSessionID);
};

/**
 * Get a list of all available offers for a specific trigger type. Note: Currently only type = deposit is supported
 * @param {string} playerSessionID 
 */
var getOffers = exports.getOffers = function getOffers(playerSessionID) {
  return (0, _utils.getProtected)('/bonus/offers?type=Deposit', playerSessionID);
};

exports.default = {
  getBonuses: getBonuses,
  getBonusById: getBonusById,
  getFreeSpins: getFreeSpins,
  getMonetaryBonuses: getMonetaryBonuses,
  getPendingBonuses: getPendingBonuses,
  claimBonus: claimBonus,
  rejectBonus: rejectBonus,
  cancelBonus: cancelBonus,
  preclaimBonus: preclaimBonus,
  triggerBonusByPromoCode: triggerBonusByPromoCode,
  getOffers: getOffers
};